import React, { Component, Fragment, createRef } from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { withWidth } from '@material-ui/core'
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withTranslations from '../../translations';

import { setFeedbackAction } from '../../actions/feedback';
import {
  setFormSubmitting,
  downloadFile,
  setImages,
  addNonStandardImage,
  deleteImages,
  addImage,
  setNonStandardImages,
  setAdditionalImages,
  setFilesToUpload,
  editPictureComment,
  editPictureCommentLockedJob,
  saveAnswers,
} from '../../actions/form';

import { setCameraButtonPosition } from '../../actions/authentication';

import http from '../../utils/http';
import { dashToCamelCase } from '../../utils/utils';

import { getViewport } from './utils';

import {
  isFileTooLarge,
  MAX_FILE_SIZE_MB,
} from './constants';

import {
  additionalFilesKey,
  checkIfAdditionalFilesQuestion,
} from '../../constants/uploadFiles';

import {
  AlertDialog,
  AlertDialogMobile,
  Button,
  Collapse,
  ConfirmationDialog,
  DialogContentText,
  FormControl,
  InputLabel,
  Input,
  List,
  Select,
} from '../base';

import {
  RenderImageFile,
  RenderOtherFile,
} from './RenderFile';

import FilePreviewModal from '../FilePreviewModal/FilePreviewModal';

import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';

import { timeFormat } from '../../constants/time';
import {
  sanitizeString,
  spacesToUnderscores,
} from '../../utils/utils';
import { QuestionSectionNames } from '../../views/SingleJob/constants';

const styles = theme => ({
  fileInputContainer: {
    width: '100%',

    '& label.actionMode': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    '&.actionMode': {
      '& > div': {
        height: '100%',

        '& > div': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
  },
  uploadLabel: {
    margin: theme.spacing(2, 0),
  },
  uploadButton: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 0),
    lineHeight: 1.45,

    '&.actionMode.MuiButtonBase-root': {
      height: 50,
      width: '100%',
      textAlign: 'center',

      '&.win': {
        fontSize: 12,

        [theme.breakpoints.up('md')]: {
          fontSize: 16,
        },
      },

      [theme.breakpoints.up('sm')]: {
        width: '75%',
      },

      [theme.breakpoints.up('md')]: {
        height: 70,
        width: '90%',
      },
    },

    '&.special': {
      border: `2px solid ${theme.palette.secondary.main}`,
      color: theme.palette.secondary.main,
    },
  },
  upload: {
    display: 'none',
  },
  fileList: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: 0,
    alignItems: 'flex-start',

    '&.actionMode': {
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      alignContent: 'flex-start',
      overflowY: 'auto',

      '&.noFilesUploaded': {
        justifyContent: 'center',
        alignItems: 'center',
      }
    },

    '@media (orientation: landscape)': {
      marginBottom: theme.spacing(),
    },
  },
  errorText: {
    color: theme.palette.error.light,

    '& .errorFile': {
      color: theme.palette.text.secondary,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      marginLeft: theme.spacing(),
    }
  },
  uploadProgressModal: {
    zIndex: `1500 !important`,
  },
  confirmDeleteDialog: {
    zIndex: `1500 !important`,
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },

    '& label': {
      width: '70%',

      [theme.breakpoints.up('md')]: {
        width: '50%',
      },

      [theme.breakpoints.up('lg')]: {
        width: '35%',
      },
    },

    '& .MuiButtonBase-root': {
      width: '95%',
    }
  },
  videoDisabled: {
    display: 'none',
  },
  videoContainer: {
    position: 'absolute',
    display: 'block',
    zIndex: 9999,
    bottom: 0,
    right: 0,
    left: 0,
    top: 0,
    background: 'white',
  },
  video: {
    position: 'absolute',
    display: 'block',
    zIndex: 10000,
    bottom: 0,
    right: 0,
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
  },
  videoButtonDisabled: {
    display: 'none',
  },
  videoButtonAndArrowsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10001,
    width: 150,
    height: 150,
    borderRadius: '50%',
    position: 'absolute',
    bottom: 0,
    left: '30%',

    [theme.breakpoints.up('sm')]: {
      left: '41%',
    },

    [theme.breakpoints.up('md')]: {
      left: '41%',
      width: 200,
      height: 200,
    },
  },
  videoButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10001,
    background: theme.palette.secondary.main,
    width: 50,
    height: 50,
    borderRadius: '50%',
    position: 'absolute',
    bottom: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      width: 100,
      height: 100,
      bottom: theme.spacing(3),
    },

    [theme.breakpoints.up('md')]: {
      width: 150,
      height: 150,
    },
  },
  arrowLeft:{
    zIndex: 10001,
    position: 'relative',
    color: theme.palette.secondary.main,
    fontSize: 45,
    left: '-14%',
    bottom: '-32px',

    [theme.breakpoints.up('sm')]: {
      fontSize: 70,
      bottom: 0,
      left: '-25%',
    },

    [theme.breakpoints.up('md')]: {
      left: '-32%',
    },
  },
  arrowRight: {
    zIndex: 10001,
    position: 'relative',
    color: theme.palette.secondary.main,
    fontSize: 45,
    left: '14%',
    bottom: -32,

    [theme.breakpoints.up('sm')]: {
      fontSize: 70,
      bottom: 0,
      left: '25%',
    },

    [theme.breakpoints.up('md')]: {
      left: '32%',
    },
  },
  arrowCenter: {
    zIndex: 10001,
    position: 'absolute',
    color: theme.palette.secondary.main,
    fontSize: 65,
    bottom: -32,
    left: '27%',

    [theme.breakpoints.up('sm')]: {
      fontSize: 70,
      bottom: -32,
    },

    [theme.breakpoints.up('md')]: {
      left: '23%',
      fontSize: 110,
      bottom: -60,
    },
  },
  visibilityHiddenClass: {
    visibility: 'hidden',
  },
  center: {
  },
  left: {
    left: '-10%',
    right: '80%',
    bottom: '43%',

    [theme.breakpoints.up('sm')]: {
      bottom: '30%',
      left: '-2%',
    },

    [theme.breakpoints.up('md')]: {
      bottom: '37%',
      left: '-1%',
    }
  },
  right: {
    left: '70%',
    bottom: '43%',

    [theme.breakpoints.up('sm')]: {
      left: '82%',
      bottom: '30%',
    },

    [theme.breakpoints.up('md')]: {
      bottom: '37%',
    },

    [theme.breakpoints.up('lg')]: {
      left: '88%',
    }
  },
  videoButton: {
    zIndex: 10001,
    background: theme.palette.secondary.main,
    fontSize: 10,
    width: 42,
    height: 42,
    border: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '50%',
    bottom: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      width: 92,
      height: 92,
      bottom: theme.spacing(3),
    },

    [theme.breakpoints.up('md')]: {
      width: 142,
      height: 142,
    },
  },
  videoCloseButton: {
    display: 'block',
    zIndex: 10001,
    background: theme.palette.error.light,
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  canvas: {
    display: 'none',
    width: '100%',
    height: '100%',
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
});

class InputFile extends Component {
  state = {
    uuids: [],
    files: [],
    previewFile: null,
    confirmDeleteFile: null,
    loaded: 0,
    uploading: false,
    uploadProgressModal: false,
    moveFileDialog: false,
    editPictureCommentDialog: false,
    pictureComment: null,
    totalFiles: 0,
    currentUploadIndex: -1,
    uploadError: false,
    additionalUuids: [],
    additionalFiles: [],
    videoDisabled: true,
    isTakeSpecialPicture: false,
    subsectionToMove: null,
    questionToMove: null,
    cameraButtonPosition: this.props.user.cameraButtonPosition,
  }

  videoRef = createRef();
  canvasRef = createRef();

  componentDidMount() {
    const { files, uuids, additionalUuids, isActionMode, field, addImgs, nonStandardImages, answers } = this.props;

    isActionMode && this.props.actions.addImage(files.filter(img1 => !this.props.imgs.filter(img => img.name === img1.name).length));

    isActionMode && !addImgs.length && field.key.includes('AdditionalImages') && this.props.actions.setAdditionalImages(files);

    isActionMode && !field.key.includes('AdditionalImages') && this.props.actions.addNonStandardImage(files.filter(img1 => img1.thumbnail.includes('extra') && !nonStandardImages.filter(img => img.name === img1.name).length));

    isActionMode && answers && this.setState({ uuids: answers[field.key]});

    const additionalImagesQuestionKey = answers && Object.keys(answers).filter(a => a.includes('AdditionalImages'));

    isActionMode && answers && this.setState({ additionalUuids: answers[additionalImagesQuestionKey] ? answers[additionalImagesQuestionKey] : []});

    !isActionMode && this.setState({ files, uuids });
    // Set existing aditional files uuids
    if (additionalUuids && !isActionMode) this.setState({additionalUuids});
   }

  componentDidUpdate(prevProps, prevState) {
    const { files, isActionMode } = this.props;

    if (this.state.uploading && !this.state.uploadProgressModal) {
      !isActionMode && this.openModal('uploadProgressModal')
    }

    if (JSON.stringify(prevProps.files) !== JSON.stringify(files)) {
      this.setState({files})
    }
  }

  closeModal = name => this.setState({ [name]: null })

  openModal = (name, uuid = true) => this.setState({ [name]: uuid })

  openCommentPictureModal = (name, uuid, alternativeDescription) => this.setState({ [name]: uuid, pictureComment: alternativeDescription})

  handleSelect = name => e => this.setState({ [name]: e.target.value })

  setFileSizeError = name => this.setState(prevState => ({ uploadError: [...prevState.uploadError, name] }))

  // Since mobile / tablet camera generated file names are not descriptive, we try to figure out
  // whether the image name was auto-generated (if it has more than 67% digits)
  shouldGenerateWholeFileName = name => Math.ceil(name.length * 2 / 3) <= name.replace(/[^0-9]/g,"").length

  generateFileName = (key, file, isSpecial) => {
    const { files } = this.state;
    const timeUTC = moment.utc(new Date()).format(timeFormat.FILE_CREATED_AT);
    const special = isSpecial ? '_extra' : '';
    const nameParts = file.name.split('.');
    const extensionIndex = nameParts.length - 1;
    const extension = nameParts[extensionIndex];
    const fileName = sanitizeString(spacesToUnderscores(nameParts.slice(0, extensionIndex).join('_')))

    return this.shouldGenerateWholeFileName(file.name)
      ? `${timeUTC}_${key}_file_${files.length + 1}${special}.${extension}`
      : `${timeUTC}_${fileName}.${extension}`
  }

  handleUpload = (field, isSpecial) => e => {
    const filesToUpload = Array.from(e.target.files);

    this.uploadFiles(field, isSpecial, filesToUpload);
  }

  saveFileDataToSession = (jobId, section, location, data) => {
    let questionAnswerSession = JSON.parse(sessionStorage.getItem('questionAnswerSession'));
      if (!questionAnswerSession) {
        questionAnswerSession = { [jobId]: { [section]: { files: [{ ...data, location }] }}};
      } else if (!questionAnswerSession[jobId]) {
        questionAnswerSession = { ...questionAnswerSession, [jobId]: { [section]: { files: [{ ...data, location}] }}};
      } else if (!questionAnswerSession[jobId][section]) {
        questionAnswerSession[jobId] = { ...questionAnswerSession[jobId], [section]: { files: [{ ...data, location }] }};
      } else if (!questionAnswerSession[jobId][section].files) {
        questionAnswerSession[jobId][section].files = [{ ...data, location }];
      } else {
        questionAnswerSession[jobId][section].files = [...questionAnswerSession[jobId][section].files, { ...data, location }];
      }
      sessionStorage.setItem('questionAnswerSession', JSON.stringify(questionAnswerSession));
  }

  uploadFiles = async (field, isSpecial, filesToUpload, name) => {
    const { key, section } = field;
    const isWindows = navigator.platform.includes('Win');

    isWindows && name && filesToUpload.map(file => file.name = name);

    const keyOfAdditionalFilesQuestion = additionalFilesKey(key);

    // Lock the form until upload is done.
    this.props.actions.setFormSubmitting(true);

    // We already know how many files are being uploaded in a batch.
    this.setState({totalFiles: filesToUpload.length})

    for (let [ind, file] of filesToUpload.entries()) {
      // Uploading has started, set all flags accordingly.
      this.setState({ loaded: 0, uploading: true, currentUploadIndex: ind + 1 })
      this.props.isActionMode && this.props.actions.setFilesToUpload('+');
      // If a file is larger than max allowed size, set error and skip the upload.
      if (isFileTooLarge(file.size)) {
        this.setFileSizeError(file.name);
        continue;
      }

      const data = new FormData();

      // Generate new file name
      const fileName = this.generateFileName(key, file, isSpecial);

      data.append('file', file, fileName);

      // Keep track of file upload progress.
      const config = {
        onUploadProgress: e => this.setState({ loaded: e.loaded / e.total * 100 })
      }

      // Upload each file individually.
      try {
        const { data: response } = await http.postWithFiles(this.props.uploadEndpoint, data, config);
        // 'name' is actually uuid - it is always unique due to timestamp
        const { name } = response.data;

        // Save uuid for the answer, and other info for preview and download.
        // Differentiate regular upload and upload of additional files.
        if (isSpecial) {
          this.setState(prevState => ({
            additionalUuids: [...prevState.additionalUuids, name],
            additionalFiles: [...prevState.additionalFiles, response.data]
          }))
          this.props.actions.addNonStandardImage(response.data, key);
        } else {
          !this.state.uuids && this.setState({uuids: []}) 
          this.setState(prevState => ({
            uuids: [...prevState.uuids, name],
            files: [...prevState.files, response.data]
          }));

          this.saveFileDataToSession(this.props.jobId, section, key, response.data);

          key.includes('AdditionalImages') ? this.props.actions.setAdditionalImages(this.props.addImgs.concat(response.data)) : this.props.actions.addImage(response.data, key);
        }
      } catch (e) {
        this.props.actions.setFeedback(e.message)
      }
    }

    // Upload is done, clear everything
    this.setState(prevState => ({
      uploading: false,
      uploadProgressModal: !!prevState.uploadError,
      currentUploadIndex: 0,
    }))
    this.props.isActionMode && this.props.actions.setFilesToUpload('-');
    // Save answer as an array of file uuids
    this.props.handleFieldChange(key, this.state.uuids, field, false);

    // Save answer for additional files (ActionMode only)
    // No need to do this if the current question is AdditionalFiles
    if (this.state.additionalUuids.length && key !== keyOfAdditionalFilesQuestion) {
      this.props.handleFieldChange(keyOfAdditionalFilesQuestion, this.state.additionalUuids, field, false);
    }

    this.props.actions.setFormSubmitting(false);
  }

  getNewStateForFiles = (oldFiles, newData) => {
    return oldFiles.map(af => {
      if (af.name === newData.name) {
        return newData;
      } else {
        return af;
      }
    });
  }

  updateFilesAfterRotate = (isSpecial, data) => {
    if (isSpecial) {
      this.setState({ additionalFiles: this.getNewStateForFiles(this.state.additionalFiles, data) });
    } else {
      this.setState({ files: this.getNewStateForFiles(this.state.files, data) });
    }
  }

  handleUploadProgressModalConfirm = () =>
    this.setState({
      uploadProgressModal: false,
      uploadError: false
    })

  displayFailedFiles = errors => errors.map(error => <p key={error} className='errorFile'>{error}</p>)

  renderUploadError = () => {
    const { gt, classes: c } = this.props;
    const { uploadError } = this.state;

    return (
      uploadError && uploadError.length
      ? <div className={c.errorText}>
          {gt.Forms.errors.uploadFailed}:
          {this.displayFailedFiles(uploadError)}
          {gt.Forms.errors.maxFileSize} {`${MAX_FILE_SIZE_MB}Mb.`}
        </div>
      : null
    );
  }

  renderUploadProgressModal = (gt, c) => {
    const { currentUploadIndex, totalFiles, uploadError, uploading, loaded } = this.state;

    return (
      <AlertDialogMobile
        className={c.uploadProgressModal}
        open={!!this.state.uploadProgressModal}
        cancelHidden
        confirmButtonText={gt.close}
        confirmDisabled={!uploadError || uploading}
        handleConfirm={this.handleUploadProgressModalConfirm}
      >
        <p>{`${gt.uploading} ${currentUploadIndex || totalFiles}/${totalFiles}: ${loaded.toFixed(2)}%`}</p>
        {this.renderUploadError()}
      </AlertDialogMobile>
    );
  }

  // There is no API call - we just update the uuids array
  handleDelete = async (key, id) =>
    this.setState(prevState =>
      ({
        files: prevState.files.filter(file => file.name !== id),
        uuids: prevState.uuids.filter(uuid => uuid !== id),
        confirmDeleteFile: null,
        previewFile: null,
      }),
      () => this.props.handleFieldChange(key, this.state.uuids)
    )

  handleDeleteFileCancel = () => this.closeModal('confirmDeleteFile');

  handleCamera = async (e, defaultConstraints = null) => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const [viewportWidth, viewportHeight] = getViewport();
      const videoRef = this.videoRef;
      const constraints = defaultConstraints || {
        video: {
          width: viewportWidth,
          height: viewportHeight,
          facingMode: 'environment',
        },
      };

      this.setState({ videoDisabled: false });

      navigator.mediaDevices.getUserMedia(constraints)
      .then(function(stream) { videoRef.current.srcObject = stream; })
      .catch(e => {
          if (e.name === 'OverconstrainedError') {
            this.handleCamera(null, {video: {width: viewportWidth, height: viewportHeight}})
          }
      });
    } else {
      console.log("getUserMedia is not supported!");
    }
  }


  handleScreenShot = e => {
    const isSpecial = this.state.isTakeSpecialPicture;
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    const [viewportWidth, viewportHeight] = getViewport();
    canvas.width = viewportWidth;
    canvas.height = viewportHeight;
    canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
    const isWindows = navigator.platform.includes('Win');

    const canvasURL = canvas.toDataURL();
    fetch(canvasURL)
      .then(res => res.blob())
      .then(blob => {
        const file = isWindows
                     ? new Blob([blob], {type: 'image/png'})
                     : new File([blob], '1111111111111111.png', {type: 'image/png'});

        this.uploadFiles(this.props.field, isSpecial, [file], '1111111111111111.png');
      }
    )

    this.setState({ videoDisabled: true });
    video.srcObject && video.srcObject.getTracks().forEach(track => track.stop());

    if (isSpecial) {
      this.setState({ isTakeSpecialPicture: false });
    }
  }

  downloadFile = fileName => {
    this.props.actions.downloadFile(this.props.jobId, fileName);
  }

  getPotentialSubsectionsToMove = (questions, key) =>{
    return questions.reduce((acc, q) => {
      if (
           q.type === 'subsection'
        && !q.key.includes('_AdditionalFiles') && !q.key.includes(key.split('_')[1])
        && q.fields && q.fields.find(({ type, shouldHide, control }) =>
          type === 'file' && !shouldHide && ['*/*', 'image/*', ''].includes(control))
      ) {
        return [...acc, {value: q.key, label: q.label}];
      }

      return acc;
    }, [])}

  getPotentialQuestionsToMove = (questions, subsection) => {
    const ss = questions.find(q => q.key === subsection);
    const potentialQuestions = ss && ss.fields && ss.fields.filter(q =>
      q.type === 'file' && !q.shouldHide && ['*/*', 'image/*', ''].includes(q.control));

    return potentialQuestions && potentialQuestions.length
      ? potentialQuestions.reduce((acc, q) => [...acc, {value: q.key, label: q.label}], [])
      : [];
  }

  handleMoveFileCancel = () => this.setState({
    subsectionToMove: null,
    questionToMove: null,
    moveFileDialog: false,
  })

  handleEditPictureCommentCancel = () => this.setState({
    editPictureCommentDialog: false,
    pictureComment: null,
  })

  handleMoveFileConfirm = async (fileId, moveFromKey, moveToQuestion) => {
    const updatedFileList = moveToQuestion.answer ? moveToQuestion.answer.concat(fileId) : [fileId];

    await this.handleDelete(moveFromKey, fileId);
    this.props.handleFieldChange(moveToQuestion.key, updatedFileList, moveToQuestion, false, true);
    this.handleMoveFileCancel();
  }

  handleEditPictureCommentModalConfirm = async () => {
    const { editPictureCommentDialog, pictureComment } = this.state;

    this.props.formName === QuestionSectionNames.CONFORMITY_TEST
      ? await this.props.actions.editPictureCommentLockedJob(this.props.jobId, editPictureCommentDialog, pictureComment, this.props.field.section)
      : await this.props.actions.editPictureComment(this.props.jobId, editPictureCommentDialog, pictureComment, this.props.field.section);

    this.setState({ editPictureCommentDialog: false});
  }

  renderDeleteConfirmationDialog = (key, c, gt) =>
    <ConfirmationDialog
      className={c.confirmDeleteDialog}
      open={!!this.state.confirmDeleteFile}
      title={gt.confirmationDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handleDeleteFileCancel}
      handleConfirm={() => this.handleDelete(key, this.state.confirmDeleteFile)}
    >
      <DialogContentText>{gt.confirmDeleteFileDialogContent}</DialogContentText>
    </ConfirmationDialog>

  renderFilePreviewModal = field => {
    const {
      isActionMode,
      shouldSaveForm,
      isSubmitting,
      rotateImageEndpoint,
      imgs,
      nonStandardImages,
      user,
    } = this.props;
    const { previewFile, files, additionalFiles } = this.state;
    const checkIfImage = filesToCheck => filesToCheck && filesToCheck.filter(file => file.mimeType && file.mimeType.startsWith('image'));
    const imageFiles = checkIfImage(files);
    const imageAdditionalFiles = checkIfImage(additionalFiles);
    const imageFilesActionMode = checkIfImage(imgs).filter(img => img.name.includes(this.props.field.key) || (img.location && img.location.includes(this.props.field.key)));
    const imageAdditionalFilesActionMode = checkIfImage(nonStandardImages).filter(img => img.name.includes(this.props.field.key)  || (img.location && img.location.includes(this.props.field.key)));
    const filesToShow = isActionMode ? [...imageFilesActionMode, ...imageAdditionalFilesActionMode] : [...imageFiles, ...imageAdditionalFiles];
    const initialIndex = filesToShow && filesToShow.findIndex(file => file.name === previewFile);
    const isAdditional = !!checkIfAdditionalFilesQuestion(field);

    return (
      previewFile
      ? <FilePreviewModal
          open={!!previewFile}
          name='preview file'
          user={user}
          onClose={() => this.closeModal('previewFile')}
          question={field.key}
          files={filesToShow}
          initialIndex={initialIndex}
          initialUuid={previewFile}
          openModal={this.openModal}
          shouldSaveForm={shouldSaveForm}
          isActionMode={isActionMode}
          downloadFile={this.downloadFile}
          isAdditional={isAdditional}
          isSubmitting={isSubmitting}
          rotateImageEndpoint={rotateImageEndpoint}
          updateFilesAfterUpload={this.updateFilesAfterRotate.bind(this, this.state.isTakeSpecialPicture)}
        />
      : null
    );
  }

  renderMoveFileModal = (gt, t, c, section) => {
    const { key } = this.props.field;
    const { moveFileDialog, subsectionToMove, questionToMove } = this.state;
    const { sections, isSubmitting } = this.props;
    const currentSection = dashToCamelCase(section);
    const questions = sections[currentSection];
    const moveToSubsection = questions.find(q => q.key === subsectionToMove);
    const moveToQuestion = moveToSubsection ? moveToSubsection.fields.find(q => q.key === questionToMove) : null;

    return (
      <AlertDialog
        open={!!moveFileDialog}
        title={t.title}
        handleCancel={this.handleMoveFileCancel}
        handleConfirm={() => this.handleMoveFileConfirm(moveFileDialog, key, moveToQuestion)}
        confirmButtonText={t.confirmButtonText}
        cancelButtonText={gt.cancel}
        confirmDisabled={isSubmitting || !this.state.questionToMove}
      >
        <FormControl fullWidth className={c.marginBottom}>
          <InputLabel>{t.selectSubsection}</InputLabel>
          <Select
            hasNullOption={false}
            options={this.getPotentialSubsectionsToMove(questions, key)}
            value={subsectionToMove || []}
            onChange={this.handleSelect('subsectionToMove')}
          />
        </FormControl>
        <FormControl fullWidth className={c.marginBottom}>
          <InputLabel>{t.selectQuestion}</InputLabel>
          <Select
            hasNullOption={false}
            disabled={!subsectionToMove}
            options={subsectionToMove ? this.getPotentialQuestionsToMove(questions, subsectionToMove) : []}
            value={questionToMove || []}
            onChange={this.handleSelect('questionToMove')}
          />
        </FormControl>
      </AlertDialog>
    )
  }

  renderEditPictureCommentModal = (gt, t) => {
    const { editPictureCommentDialog, pictureComment } = this.state;

    return (
      <AlertDialog
        open={!!editPictureCommentDialog}
        title={t.commentPicture}
        confirmButtonText={t.confirmButtonText}
        cancelButtonText={gt.cancel}
        handleConfirm={this.handleEditPictureCommentModalConfirm}
        handleCancel={this.handleEditPictureCommentCancel}
        confirmDisabled={!pictureComment}
      >
        <Input
          fullWidth
          inputProps={{ maxLength: 100 }}
          onChange={e => this.setState({ pictureComment: e.target.value })}
          value={pictureComment || ''}
        />
      </AlertDialog>
    )
  }

  changePosition = async arrowDirection => {
    const { setCameraButtonPosition } = this.props.actions;

    switch (arrowDirection) {
      case 'center':
        await setCameraButtonPosition('center');
        this.setState({ cameraButtonPosition: 'center' });
        break;
      case 'left':
        await setCameraButtonPosition('left');
        this.setState({ cameraButtonPosition: 'left' });
        break;
      case 'right':
        await setCameraButtonPosition('right');
        this.setState({ cameraButtonPosition: 'right' });
        break;
      default:
        break;
    }
  }

  render() {
    const { files, additionalFiles, cameraButtonPosition } = this.state;
    const { classes: c, t, gt, field, renderIsRequired, isDisabled, isActionMode,
            hasSpecial, takePictureLabel, takeSpecialPictureLabel, shouldSaveForm,
            isLocked, imgs, addImgs, nonStandardImages, sections, user, formName } = this.props;
    const { control, label, key, required, shouldHide, section } = field;

    const isImage = file => file.mimeType && file.mimeType.startsWith('image') && file.thumbnail;
    const imagesFirst = file => isImage(file) ? -1 : 1;
    const sortedFiles = files && files.sort((a, b) => a.name.localeCompare(b.name)).sort(imagesFirst);
    const sortedFilesActionMode = addImgs && key.includes('AdditionalImages') ? addImgs : imgs && imgs.sort((a, b) => a.name.localeCompare(b.name)).sort(imagesFirst).filter(img => img.location && img.location === key);

    const additionalFilesActionMode = nonStandardImages && nonStandardImages.sort((a, b) => a.name.localeCompare(b.name)).sort(imagesFirst).filter(img => img.location && img.location === key);

    const actionClass = isActionMode ? 'actionMode' : '';
    const special = hasSpecial ? 'special' : '';
    const id = isActionMode ? key + '_ActionMode' : key;
    const isAdditional = !!checkIfAdditionalFilesQuestion(field);
    const isNotWindowsDevice = !navigator.platform.includes('Win');
    const visibilityHiddenClass = position => cameraButtonPosition === position ? c.visibilityHiddenClass : '';

    const sectionNameArray = field.section.split('-');
    sectionNameArray[1] = sectionNameArray[1].charAt(0).toUpperCase() + sectionNameArray[1].slice(1)

    const subSection = sections && sections[sectionNameArray.join('')].filter(field => field.fields.filter(field => field.key === key && field.control.includes('image')).length);

    const images = subSection && subSection[0] && subSection[0].fields && subSection[0].fields.filter(file => file.key === key).length && subSection[0].fields.filter(file => file.key === key)[0].files

    sortedFiles.length && sortedFiles.map(function(file) {
      const foundImage = images && images.length && images.filter(image => image.uuid === file.uuid)[0];
      foundImage && (file.alternativeDescription || file.alternativeDescription === null) && (file.alternativeDescription = foundImage.alternativeDescription);
      return true;
    })

    const imageOperationsLocked = (isLocked && formName !== QuestionSectionNames.CONFORMITY_TEST) || shouldSaveForm;

    return (
      <Collapse in={!shouldHide || !!required} className={classNames(c.fileInputContainer, actionClass)}>
        {!isActionMode && <div className={c.uploadLabel}>{label}</div>}
        { files.length || additionalFiles.length || sortedFiles || additionalFilesActionMode
          ? <List className={classNames(c.fileList, actionClass)}>
              { isActionMode  ?
                sortedFilesActionMode.map((file, i) => isImage(file)
                  ? <RenderImageFile key={i} imageOperationsLocked={imageOperationsLocked} user={user} file={file} openModal={this.openModal} downloadFile={this.downloadFile} isActionMode={isActionMode} isAdditional={isAdditional} gt={gt}/>
                  : <RenderOtherFile key={i} file={file} openModal={this.openModal} downloadFile={this.downloadFile} gt={gt}/>
                )
                : sortedFiles.map((file, i) => isImage(file)
                  ? <RenderImageFile key={i} imageOperationsLocked={imageOperationsLocked} user={user} file={file} openModal={this.openModal} openCommentPictureModal={this.openCommentPictureModal} downloadFile={this.downloadFile} isActionMode={isActionMode} isAdditional={isAdditional} gt={gt}/>
                  : <RenderOtherFile key={i} file={file} openModal={this.openModal} downloadFile={this.downloadFile} gt={gt}/>
              )
              }
              { isActionMode ?
                additionalFilesActionMode.map((file, i) => isImage(file)
                  ? <RenderImageFile key={i} imageOperationsLocked={imageOperationsLocked} user={user} file={file} openModal={this.openModal} downloadFile={this.downloadFile} isSpecial={special} isActionMode={isActionMode} t={t} isAdditional={isAdditional} gt={gt}/>
                  : <RenderOtherFile key={i} file={file} openModal={this.openModal} downloadFile={this.downloadFile} gt={gt}/>
                )
                : additionalFiles.map((file, i) => isImage(file)
                  ? <RenderImageFile key={i} imageOperationsLocked={imageOperationsLocked} user={user} file={file} openModal={this.openModal} downloadFile={this.downloadFile} isSpecial={special} isActionMode={isActionMode} t={t} isAdditional={isAdditional} gt={gt}/>
                  : <RenderOtherFile key={i} file={file} openModal={this.openModal} downloadFile={this.downloadFile} gt={gt}/>
              )
              }
            </List>
          : isActionMode
            ? <div className={classNames(c.fileList, actionClass, 'noFilesUploaded')}>{gt.noFilesUploaded}.</div>
            : null
        }

        {/*  Take picture overlay and controls  */}
        {
          isActionMode &&
          <div className={this.state.videoDisabled ? c.videoDisabled : c.videoContainer}>
            <video autoPlay playsInline ref={this.videoRef} className={this.state.videoDisabled ? c.videoDisabled : c.video}></video>
            <canvas className={c.canvas} ref={this.canvasRef} ></canvas>
            <div className={classNames(c.videoButtonAndArrowsContainer, c[this.state.cameraButtonPosition])}> 
              <ArrowBackIosRoundedIcon className={classNames(c.arrowLeft, visibilityHiddenClass('left'))} onClick={() => this.changePosition('left')}/>
              <ArrowForwardIosRoundedIcon className={classNames(c.arrowRight, visibilityHiddenClass('right'))} onClick={() => this.changePosition('right')}/>
              <KeyboardArrowDownRoundedIcon className={classNames(c.arrowCenter, visibilityHiddenClass('center'))} fontSize='large' onClick={() => this.changePosition('center')}/>
              <div className={c.videoButtonContainer}>
                <button
                  variant='contained'
                  onClick={this.handleScreenShot}
                  className={this.state.videoDisabled ? c.videoButtonDisabled : c.videoButton}
                >
                </button>
              </div>
            </div>
            <Button
              variant='contained'
              onClick={() => this.setState({ videoDisabled: true, isTakeSpecialPicture: false })}
              className={this.state.videoDisabled ? c.videoButtonDisabled : c.videoCloseButton}
            >
              X
            </Button>
          </div>
        }

        <div className={isActionMode ? classNames(c.fileUpload, actionClass) : ''}>
          {/* Take standard picture */}
          {
            isActionMode &&
            <Fragment>
              <input
                accept={control}
                className={c.upload}
                id={id}
                type={isNotWindowsDevice ? 'file' : null}
                onChange={isNotWindowsDevice ? this.handleUpload(field, false) : null}
                disabled={isDisabled}
              />
              <label htmlFor={id} className={actionClass}>
                <Button
                  disabled={isDisabled}
                  variant={isActionMode ? 'contained' : 'text'}
                  color='secondary'
                  component='span'
                  onClick={isNotWindowsDevice ? null : e => this.handleCamera(e, null)}
                  className={classNames(c.uploadButton, actionClass)}
                >
                  <span>{takePictureLabel}</span>
                </Button>
              </label>
            </Fragment>
          }
          {/* Upload standard picture */}
          {
            !isActionMode &&
            <Fragment>
              <input
                accept={control}
                className={c.upload}
                id={id}
                type='file'
                onChange={this.handleUpload(field, false)}
                multiple
                disabled={isDisabled}
              />
              <label htmlFor={id} className={actionClass}>
                <Button
                  disabled={isDisabled}
                  onClick={() => this.setState({isTakeSpecialPicture: false})}
                  variant={isActionMode ? 'contained' : 'text'}
                  color='secondary'
                  component='span'
                  className={classNames(c.uploadButton, actionClass)}
                >
                  <span>{t.upload}</span>
                </Button>
              </label>
            </Fragment>
          }
        </div>
        <div className={c.fileUpload}>
          {/* Take special picture */}
          {
            isActionMode && key !== additionalFilesKey(key) &&
            <Fragment>
              <input
                accept={control}
                className={c.upload}
                id={id + 'special'}
                type={isNotWindowsDevice ? 'file' : null}
                onChange={isNotWindowsDevice ? this.handleUpload(field, true) : null}
                disabled={isDisabled}
              />
              <label htmlFor={id + 'special'} className={actionClass}>
                <Button
                  disabled={isDisabled}
                  variant='text'
                  color='secondary'
                  component='span'
                  onClick={
                    isNotWindowsDevice
                    ? null
                    : e => {
                      this.setState({isTakeSpecialPicture: true})
                      this.handleCamera(e, null)
                    }
                  }
                  className={classNames(c.uploadButton, actionClass, special)}
                >
                  <span>{takeSpecialPictureLabel}</span>
                </Button>
              </label>
            </Fragment>
          }
        </div>

        {renderIsRequired(required, files, key)}

        {this.renderFilePreviewModal(field)}
        {this.renderUploadProgressModal(gt, c)}
        {this.renderDeleteConfirmationDialog(key, c, gt)}
        {this.renderMoveFileModal(gt, t.moveFileModal, c, section)}
        {this.renderEditPictureCommentModal(gt, t, c)}
      </Collapse>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  jobId: state.singleJob.id,
  sections: state.singleJob.sections,
  isSubmitting: state.form.isSubmitting,
  imgs: state.form.images,
  nonStandardImages: state.form.nonStandardImages,
  addImgs: state.form.addImages,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    setFeedback: bindActionCreators(setFeedbackAction, dispatch),
    setFormSubmitting: bindActionCreators(setFormSubmitting, dispatch),
    downloadFile: bindActionCreators(downloadFile, dispatch),
    setCameraButtonPosition: bindActionCreators(setCameraButtonPosition, dispatch),
    addImage: bindActionCreators(addImage, dispatch),
    addNonStandardImage: bindActionCreators(addNonStandardImage, dispatch),
    setImages: bindActionCreators(setImages, dispatch),
    deleteImages: bindActionCreators(deleteImages, dispatch),
    setNonStandardImages: bindActionCreators(setNonStandardImages, dispatch),
    setAdditionalImages: bindActionCreators(setAdditionalImages, dispatch),
    setFilesToUpload: bindActionCreators(setFilesToUpload, dispatch),
    editPictureComment: bindActionCreators(editPictureComment, dispatch),
    editPictureCommentLockedJob: bindActionCreators(editPictureCommentLockedJob, dispatch),
    saveAnswers: bindActionCreators(saveAnswers, dispatch)
  }
})

export default withTranslations(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withWidth()(InputFile))), 'InputFile');



// WEBPACK FOOTER //
// ./src/components/FileInput/FileInput.js